export const htmlSelectors = {
  NUCLEUS_BANNER: '[id*=sponsored-standard-banner-nucleus]',
  NUCLEUS_CAROUSEL: '[id*=sponsored-carousel-nucleus]',
  DEFAULT_BANNER: '[id*=default_banner_carousel]',

  CERTONA_WRAPPER: '.certona__wrapper',
  VISUALLY_SIMILAR: '.visually-similar',
};
